import styled from 'styled-components';

export const StyledSendToClosingHeader = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledSendToClosingContainer = styled.div`
  padding: 36px;
`;

export const StyledSendToClosingFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
`;

export const StyledSendToClosingListItem = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-top: 24px;
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 20px;
`;

export const StyledForm = styled.fieldset`
  display: flex;
  margin: 12px 0px;
  flex-direction: column;
  border: none;
  padding: 12px 0px;
`;

export const StyledFormDescription = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  line-height: 17px;
  margin-right: -8px;
`;

export const StyledFormItem = styled.div`
  height: 58px;
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

StyledFormItem.Label = styled.label`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-bottom: 6px;
`;

StyledFormItem.Input = styled.input`
  width: 216px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px;
  padding: 12px;

  &:disabled {
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }
`;

export const ACVDescription = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-top: 14px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;
